import {
  Box,
  Button,
  Dialog,
  Portal,
  RadioGroup,
  SimpleGrid,
  Skeleton,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useCallback, useEffect, useState } from 'react'
import { providersCountryOptions, providersTypeOptions } from './SmsProviders.constants'
import { useFetchProvidersSettings } from './hooks/useFetchProvidersSettings'
import { useSaveProvidersSettings } from './hooks/useSaveProvidersSettings'

export const SmsProviders = ({ isOpen, onClose }) => {
  const [providers, setProviders] = useState({})

  const { data, isLoading: settingsIsLoading } = useFetchProvidersSettings(isOpen)
  const { mutate, isLoading: settingsIsSaving } = useSaveProvidersSettings()

  useEffect(() => {
    if (data) {
      setProviders({
        armenianProvider: data.armenianProvider,
        russianProvider: data.russianProvider,
      })
    }
  }, [data])

  const onSubmitHandle = useCallback(() => {
    mutate(providers)
  }, [providers])

  const onChangeProvider = useCallback((value) => {
    setProviders((state) => ({
      ...state,
      ...value,
    }))
  }, [])

  const formIsDisabled = settingsIsLoading | settingsIsSaving
  const availableProviders = data?.availableProviders || []

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>SMS провайдеры</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Skeleton h="94px" loading={!data} borderRadius="5px">
                <VStack>
                  <SimpleGrid w="full" columns={2}>
                    {providersTypeOptions
                      .filter(({ value }) => availableProviders.includes(value))
                      .map(({ value, label }) => (
                        <Text key={value} fontWeight={500}>
                          {label}
                        </Text>
                      ))}
                  </SimpleGrid>

                  {providersCountryOptions.map((country) => (
                    <RadioGroup.Root
                      colorPalette="blue"
                      key={country.value}
                      size="lg"
                      w="full"
                      onValueChange={({ value }) => onChangeProvider({ [country.value]: value })}
                      value={providers[country.value]}
                    >
                      <Stack direction="row" justifyContent="space-around">
                        <SimpleGrid w="full" columns={2}>
                          {providersTypeOptions
                            .filter(({ value }) => availableProviders.includes(value))
                            .map(({ value }) => (
                              <RadioGroup.Item
                                key={value}
                                value={value}
                                disabled={formIsDisabled}
                                cursor="pointer"
                              >
                                <RadioGroup.ItemHiddenInput />
                                <RadioGroup.ItemIndicator cursor="pointer" />
                                <RadioGroup.ItemText>{country.label}</RadioGroup.ItemText>
                              </RadioGroup.Item>
                            ))}
                        </SimpleGrid>
                      </Stack>
                    </RadioGroup.Root>
                  ))}
                </VStack>
              </Skeleton>
              <Box pt="30px">
                <Button
                  onClick={onSubmitHandle}
                  colorPalette="orange"
                  loading={settingsIsLoading || settingsIsSaving}
                >
                  Обновить
                </Button>
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
